module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/078-belize-0a1eaccad58adef593d1bda686e00b5e.svg";